// extracted by mini-css-extract-plugin
export default {"success":"hooks_success__fTCT6","failure":"hooks_failure__W-8fQ"};